import type { RefObject } from 'react';

import { useEventListener } from './useEventListener';
import { ChatButtonTarget } from 'src/_shared/chat/ChatButton.constants';

type EventType = 'mousedown' | 'mouseup' | 'touchstart' | 'touchend' | 'focusin' | 'focusout';

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T> | RefObject<T>[],
  handler: (event: MouseEvent | TouchEvent | FocusEvent) => void,
  eventType: EventType = 'mousedown',
  eventListenerOptions: AddEventListenerOptions = {},
): void {
  useEventListener(
    eventType,
    event => {
      const target = event.target as T;

      // Do nothing if the target is not connected element with document
      if (!target || !target.isConnected) {
        return;
      }

      let isOutside = Array.isArray(ref)
        ? ref.filter(r => Boolean(r.current)).every(r => r.current && !r.current.contains(target))
        : ref.current && !ref.current.contains(target);

      // do not close any previous window when clicking on the chat button
      isOutside &&= !target.closest(ChatButtonTarget);

      if (isOutside) {
        handler(event);
      }
    },
    undefined,
    eventListenerOptions,
  );
}
